<template>
    <!-- TipDM建模平台 -->
    <section class="indBlock titLeft bgw">
        <div class="container">
            <div class="hd clearfix">
                <h3><a href="#">TipDM建模平台</a></h3>
                <div class="introTxt">基于Python引擎、用于数据挖掘建模的开源平台</div>
            </div>
            <div class="bd">
                <div class="tipdmIntro">
                    <p>TipDM是基于Python引擎、用于数据挖掘建模的开源平台。用户可在没有Python编程基础的情况下，通过拖拽的方式进行操作，将数据输入输出、数据预处理、挖掘建模、模型评估等环节，通过流程化的方式进行连接，使用户理解数据，并设计数据挖掘流程和可重用组件，以达到数据分析挖掘的目的。</p>
                    <ul>
                        <li>
                            <div class="img"><img src="@/pages/frontend/assets/images/tipdmIntro-1.jpg" /></div>
                            <div class="tit">流程式操作数据挖掘</div>
                        </li>
                        <li>
                            <div class="img"><img src="@/pages/frontend/assets/images/tipdmIntro-2.jpg" /></div>
                            <div class="tit">支持多种数据来源方式</div>
                        </li>
                        <li>
                            <div class="img"><img src="@/pages/frontend/assets/images/tipdmIntro-3.jpg" /></div>
                            <div class="tit">数据加工</div>
                        </li>
                        <li>
                            <div class="img"><img src="@/pages/frontend/assets/images/tipdmIntro-4.jpg" /></div>
                            <div class="tit">提供丰富的机器学习算法</div>
                        </li>
                        <li>
                            <div class="img"><img src="@/pages/frontend/assets/images/tipdmIntro-5.jpg" /></div>
                            <div class="tit">一键分享</div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="fd">
                <a class="btn bigBtn blueSty hoverShadow" href="#" @click="applyHandle">申请试用</a>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        created() {
        },
        mounted:function(){
        },
        methods: {
            applyHandle(){
                window.open('http://python.tipdm.com.cn/login_banner');
            }

        }
    };
</script>